var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7254af",
    width: "64px",
    height: "64px",
    viewBox: "-4.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "camera"), /*#__PURE__*/React.createElement("path", {
    d: "M18.281 8.719h2.125c1.438 0 2.625 1.156 2.625 2.625v11.375c0 1.438-1.188 2.625-2.625 2.625h-17.781c-1.438 0-2.625-1.188-2.625-2.625v-11.375c0-1.469 1.188-2.625 2.625-2.625h2.156c0.531-0.844 1.5-2.063 2.375-2.063h8.719c0.875 0 1.875 1.219 2.406 2.063zM11.438 22.031c3.219 0 5.844-2.625 5.844-5.844 0-3.25-2.625-5.875-5.844-5.875-3.25 0-5.906 2.625-5.906 5.875 0 3.219 2.656 5.844 5.906 5.844zM11.531 12.656c1.938 0 3.5 1.594 3.5 3.531 0 1.906-1.563 3.5-3.5 3.5s-3.531-1.594-3.531-3.5c0-1.938 1.594-3.531 3.531-3.531z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCameraIcon);
export default __webpack_public_path__ + "static/media/new-camera-icon.b663f769f78f6226d12828d92d09fcc0.svg";
export { ForwardRef as ReactComponent };